export default function validateLogin (values) {
  let errors = {}

  // Email Errors
  if (!values.email) {
    errors.email = 'Email required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = 'Vigane aadress'
  }
  // Password Errors
  if (!values.password) {
    errors.password = 'Password required'
  } else if (values.password.length < 4) {
    errors.password = 'Vähem kui 4 märki pikk'
  }

  return errors
}
